import { forwardRef, useState, useEffect } from 'react';
import DropdownReg from '../../dropdownReg/DropdownReg';
import MultiSelect from '../../multiselect/multiselect';
import { fetchTypesData } from './fetchTypes/FetchTypes';
import './quickView.css';
import useSectionHighlightRef from '../../../hooks/useSectionHighlightRef';
import DirectInput from '../../directInput/DirectInput';

const QuickView = forwardRef(({ packData, setPackData }, ref) => {
    const { sectionRef, highlightField } = useSectionHighlightRef(ref);
    const diffDrop = ['Easy', 'Medium', 'Difficulty'];
    const foodDrop = ['Veg', 'Non-veg', 'Veg & Non-veg'];
    const [typeSel, setTypeSel] = useState('trip');
    const [typesData, setTypesData] = useState([]);
    useEffect(() => {
        fetchTypesData(typeSel, 'Types', setTypesData);
    }, [typeSel]);

    useEffect(() => {
        setTypeSel((prev) => prev);
    }, []);

    return (
        <div ref={sectionRef}>
            <h2 className='orgPackUpH2'>Quick View</h2>
            <div className='orgPackUpSecDiv'>
                <MultiSelect
                    label='Type / Category'
                    helperText='*Can select multiple types'
                    name='type'
                    value={packData?.quickView?.type || []}
                    data={typesData}
                    listAll={true}
                    closeListOnItemSelect={false}
                    onChange={(val) => {
                        setPackData((prev) => ({
                            ...prev,
                            quickView: {
                                ...prev.quickView,
                                type: val
                            }
                        }));
                    }}
                    error={highlightField === 'type'}
                />
                <DropdownReg
                    label='Difficulty'
                    name={'difficulty'}
                    options={diffDrop}
                    value={packData?.quickView?.difficulty}
                    req={true}
                    setFormData={setPackData}
                    nest='quickView'
                    error={highlightField === 'difficulty'}
                />
                <DirectInput
                    label='Start Time'
                    name='startTime'
                    value={packData?.quickView?.startTime}
                    type='text'
                    placeholder='Ex - 9:00 PM'
                    setFormData={setPackData}
                    min={6}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'startTime'}
                />
                <DirectInput
                    label='End Time'
                    name='endTime'
                    value={packData?.quickView?.endTime}
                    type='text'
                    placeholder='Ex - 9:00 PM'
                    setFormData={setPackData}
                    min={6}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'endTime'}
                />
                <DirectInput
                    label='Duration'
                    name='duration'
                    value={packData?.quickView?.duration}
                    type='text'
                    placeholder='2D/1N'
                    setFormData={setPackData}
                    min={2}
                    limit={9}
                    nest='quickView'
                    error={highlightField === 'duration'}
                />
                <DirectInput
                    label='Stay'
                    name='stay'
                    value={packData?.quickView?.stay}
                    type='text'
                    placeholder='Tent, Sharing rooms'
                    setFormData={setPackData}
                    min={6}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'stay'}
                />
                <DirectInput
                    label='Where'
                    name='where'
                    value={packData?.quickView?.where}
                    type='text'
                    placeholder='Destination district. Ex - Chikamagluru'
                    setFormData={setPackData}
                    min={2}
                    limit={30}
                    nest='quickView'
                    error={highlightField === 'where'}
                />
                <DropdownReg
                    label='Food'
                    name={'food'}
                    options={foodDrop}
                    value={packData?.quickView?.food}
                    req={true}
                    setFormData={setPackData}
                    nest='quickView'
                    error={highlightField === 'food'}
                />
                <DirectInput
                    label='Trek Distance'
                    name='trekDistance'
                    value={packData?.quickView?.trekDistance}
                    type='text'
                    placeholder='Trek distance in km (Ex - 2 km), if Not a trek just enter 0 km'
                    setFormData={setPackData}
                    min={3}
                    limit={8}
                    nest='quickView'
                    error={highlightField === 'trekDistance'}
                />
                <DirectInput
                    label='Base Cities'
                    name='baseCities'
                    value={packData?.quickView?.baseCities}
                    type='text'
                    placeholder='Starting cities (ex - Bengaluru, Mysuru)'
                    setFormData={setPackData}
                    min={3}
                    limit={40}
                    nest='quickView'
                    error={highlightField === 'baseCities'}
                />
            </div>
        </div>
    );
});

export default QuickView;
